"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAdornmentWrapper = exports.StyledTextFieldAdornmentWrapper = exports.StyledTextArea = exports.StyledTextField = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _commonElements = require("../utils/commonElements");

var _helpers = require("../utils/helpers");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // Copyright 2019 Esri
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​


var StyledTextField = (0, _styledComponents.default)(_commonElements.CalciteInput).withConfig({
  displayName: "StyledTextField",
  componentId: "wcvteo-0"
})(["", ";", ";"], function (props) {
  return props.hasAdornmentLeft && (0, _styledComponents.css)(["border-left:none;border-top-left-radius:0;border-bottom-left-radius:0;"]);
}, function (props) {
  return props.hasAdornmentRight && (0, _styledComponents.css)(["border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;"]);
});
exports.StyledTextField = StyledTextField;
var StyledTextArea = (0, _styledComponents.default)(_commonElements.CalciteTextarea).withConfig({
  displayName: "StyledTextArea",
  componentId: "wcvteo-1"
})(["", ";", ";"], function (props) {
  return props.hasAdornmentLeft && (0, _styledComponents.css)(["border-left:none;border-top-left-radius:0;border-bottom-left-radius:0;"]);
}, function (props) {
  return props.hasAdornmentRight && (0, _styledComponents.css)(["border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;"]);
});
exports.StyledTextArea = StyledTextArea;

var StyledTextFieldAdornmentWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledTextFieldAdornmentWrapper",
  componentId: "wcvteo-2"
})(["display:flex;", ";"], function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["width:100%;"]);
});

exports.StyledTextFieldAdornmentWrapper = StyledTextFieldAdornmentWrapper;

var StyledAdornmentWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledAdornmentWrapper",
  componentId: "wcvteo-3"
})(["display:flex;align-items:center;justify-content:center;margin:", " 0 0 0;padding:0 ", ";background:", ";color:", ";fill:currentColor;border:1px solid ", ";border-radius:", ";min-width:", ";input + &{border-right:1px solid ", ";}", ";", ";", ";"], function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 6, '/');
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
}, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.darkerGray;
}, function (props) {
  return props.theme.palette.lightGray;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.baseline;
}, function (props) {
  return props.theme.palette.lightGray;
}, function (props) {
  return props.minimal && (0, _styledComponents.css)(["padding:0 ", ";min-width:auto;background:transparent;border:none;border-bottom:1px solid ", ";"], function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 6, '/');
  }, function (props) {
    return props.theme.palette.lighterGray;
  });
}, function (props) {
  return props.adornmentDirection === 'left' && (0, _styledComponents.css)(["border-top-right-radius:0;border-bottom-right-radius:0;"]);
}, function (props) {
  return props.adornmentDirection === 'right' && (0, _styledComponents.css)(["border-top-left-radius:0;border-bottom-left-radius:0;"]);
});

exports.StyledAdornmentWrapper = StyledAdornmentWrapper;